import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IServiceCategory } from "src/models/Stores/Store.models";

interface ServiceCategoryState {
  serviceCategorys: IServiceCategory[];
  serviceCategoryToEdit: IServiceCategory | null;
}

const initialState: ServiceCategoryState = {
  serviceCategorys: [],
  serviceCategoryToEdit: null,
};

const serviceCategoryslice = createSlice({
  name: "ServiceCategory",
  initialState,
  reducers: {
    setServiceCategoryList: (
      state,
      action: PayloadAction<IServiceCategory[]>
    ) => {
      state.serviceCategorys = action.payload;
    },
    concatListServiceCategory: (
      state: ServiceCategoryState,
      action: PayloadAction<IServiceCategory[]>
    ) => {
      state.serviceCategorys = [
        ...state.serviceCategorys.concat(action.payload),
      ];
    },
    setServiceCategoryToEdit: (
      state,
      action: PayloadAction<IServiceCategory | null>
    ) => {
      state.serviceCategoryToEdit = action.payload;
    },
    addServiceCategory: (state, action: PayloadAction<IServiceCategory>) => {
      state.serviceCategorys.push(action.payload);
    },
    updateServiceCategory: (state, action: PayloadAction<IServiceCategory>) => {
      let itemIndex = state.serviceCategorys.findIndex(
        item => item.serviceCategoryId === action.payload.serviceCategoryId
      );
      if (itemIndex !== -1) state.serviceCategorys[itemIndex] = action.payload;
    },
    deleteServiceCategory: (state, action: PayloadAction<number>) => {
      const newArray = state.serviceCategorys.filter(
        item => item.serviceCategoryId !== action.payload
      );
      state.serviceCategorys = newArray;
    },
  },
});

export const {
  setServiceCategoryList,
  concatListServiceCategory,
  setServiceCategoryToEdit,
  addServiceCategory,
  updateServiceCategory,
  deleteServiceCategory,
} = serviceCategoryslice.actions;

export default serviceCategoryslice.reducer;
